import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

const bucketColorClasses = [
  'bg-chart-intelligence-background-low-default',
  'bg-chart-intelligence-background-normal-default',
  'bg-chart-intelligence-background-high-default',
];

interface MarketSmartInsightsCalendarFooterSmartInsightsSignature {
  Args: {};
}

const MarketSmartInsightsCalendarFooterSmartInsights: TOC<MarketSmartInsightsCalendarFooterSmartInsightsSignature> =
  <template>
    <div
      class="text-200--medium footer-portfolio-smart-insights flex w-full flex-row items-center gap-100 px-500 py-300"
    >
      {{t "market.smart_insights.calendar.legend.low"}}

      {{#each bucketColorClasses as |bucketColorClass|}}
        <div class="rounded-100 h-[16px] w-[16px] {{bucketColorClass}}" />
      {{/each}}

      {{t "market.smart_insights.calendar.legend.high"}}
    </div>
  </template>;

export default MarketSmartInsightsCalendarFooterSmartInsights;
